import { createAction } from '@reduxjs/toolkit';
import { ReactElement } from 'react';
import { ToggleActionPanel, ToggleActionPanelOpened } from 'reactApp/modules/actionpanel/actionpanel.types';

export const toggleActionPanel = createAction<ToggleActionPanel | ToggleActionPanelOpened>('actionPanel/toggleActionPanel');
export const setActionPanelHeader = createAction<string | ReactElement>('actionPanel/setActionPanelHeader');
